import Box from "@mui/material/Box";
import Button from "../Buttons/Button";
import {
  BUTTON_CREATE,
  BUTTON_REPLACE,
  BUTTON_SELECT,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

const InstantFormCardActions = ({
  disabled = false,
  hasSelection = false,
  onSelect = () => {},
  onCreate = () => {},
  marginTop = 1.5,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        width: "100%",
        mt: marginTop,
      }}
    >
      <Button
        type="button"
        color="secondary"
        onClick={onSelect}
        disabled={disabled}
        sx={{ flex: 1, minWidth: 0 }}
      >
        {t(hasSelection ? BUTTON_REPLACE : BUTTON_SELECT)}
      </Button>
      <Button
        type="button"
        color="secondary"
        onClick={onCreate}
        disabled={disabled}
        sx={{ flex: 1, minWidth: 0 }}
      >
        {t(BUTTON_CREATE)}
      </Button>
    </Box>
  );
};

export default InstantFormCardActions;
